import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    // ⚠️ PRIMERO verificar si es una ruta del GPS
    if (req.url.includes('generate_report') || 
        req.url.includes('gps.indesoft.xyz') ||
        req.url.includes('/api/generate_report')) {
      // Para rutas GPS: clonar SIN credenciales
      const clonedRequestGps = req.clone({ withCredentials: false });
      return next.handle(clonedRequestGps);
    }

    // ⚠️ Rutas públicas de encuestas: sin credenciales para evitar 401
    // Aplica tanto a la ruta Angular /encuestas/responder/ como a las llamadas
    // al backend /api/public/encuesta/
    const isRutaPublica = window.location.pathname.includes('/encuestas/responder/')
      || req.url.includes('/public/encuesta/') || window.location.pathname.includes('/Asistencia/')
      || req.url.includes('/public/encuesta/');
      
      
    if (isRutaPublica) {
    //  console.log("es publica");
      return next.handle(req.clone({ withCredentials: false }));
    }

    // Para el resto de rutas: clonar CON credenciales
    const clonedRequest = req.clone({ withCredentials: true });

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        const isLogoutCall = req.url.includes('/auth/logout');
       // console.log("ingreso aqui");
        if (error.status === 401 && !isLogoutCall) {
          console.warn('🔐 Sesión expirada o no autorizada. Redirigiendo al login...');
          this.authService.clearLocalState();
          this.router.navigate(['/auth/login'], { queryParams: { sessionExpired: true } });
        }

        return throwError(() => error);
      })
    );
  }
}